import { getProductDocumentType } from '@/domain/products/api';
import { useQuery } from '@tanstack/react-query';

import {
  getItemsWithYears,
  getPortfolios,
  getResourceGroupsByPortfolio,
  getResourceGroupsOwnerByPortfolio,
  getResourcesByPortfolio,
  getResourcesOwnerByPortfolio,
} from '../api';
import { type RoadmapPortfolioDTO } from '../types';

export const PORTFOLIO_KEY = 'portfolios';
export const RESOURCE_GROUPS_BY_PORTFOLIO_KEY = 'resourceGroupsByPortfolio';
export const RESOURCE_GROUPS_OWNER_BY_PORTFOLIO_KEY = 'resourceGroupsOwnerByPortfolio';
export const RESOURCE_BY_PORTFOLIO_KEY = 'resourceByPortfolio';
export const RESOURCE_OWNER_BY_PORTFOLIO_KEY = 'resourceOwnerByPortfolio';
export const USE_PRODUCT_DOCUMENT_TYPE = 'use-product-document-type';

export const usePortfolios = (initialData?: RoadmapPortfolioDTO[]) =>
  useQuery({
    queryKey: [PORTFOLIO_KEY],
    queryFn: async () => await getPortfolios(),
    staleTime: 1000 * 60 * 15,
    initialData,
  });

export const usePortfoliosWithYears = (years: number[]) =>
  useQuery({
    queryKey: [PORTFOLIO_KEY, 'by-years', ...years.toSorted((a, b) => a - b)],
    queryFn: async () => await getItemsWithYears(years),
    staleTime: 1000 * 60 * 15,
    enabled: years.length > 0,
  });

export const useResourceGroupsByPortfolio = (roadmapIds: number[], filterCostCenter = false) =>
  useQuery({
    queryKey: [RESOURCE_GROUPS_BY_PORTFOLIO_KEY, roadmapIds, filterCostCenter],
    queryFn: async (context) => await getResourceGroupsByPortfolio(roadmapIds, filterCostCenter, context.signal),
    staleTime: 1000 * 60 * 15,
  });

export const useResourceGroupsOwnerByPortfolio = (roadmapIds: number[]) =>
  useQuery({
    queryKey: [RESOURCE_GROUPS_OWNER_BY_PORTFOLIO_KEY, roadmapIds],
    queryFn: async (context) => await getResourceGroupsOwnerByPortfolio(roadmapIds, context.signal),
    staleTime: 1000 * 60 * 15,
  });

export const useResourcesByPortfolio = (roadmapIds: number[]) =>
  useQuery({
    queryKey: [RESOURCE_BY_PORTFOLIO_KEY, roadmapIds],
    queryFn: async (context) => await getResourcesByPortfolio(roadmapIds, context.signal),
    staleTime: 1000 * 60 * 15,
  });

export const useResourcesOwnerByPortfolio = (roadmapIds: number[]) =>
  useQuery({
    queryKey: [RESOURCE_OWNER_BY_PORTFOLIO_KEY, roadmapIds],
    queryFn: async (context) => await getResourcesOwnerByPortfolio(roadmapIds, context.signal),
    staleTime: 1000 * 60 * 15,
  });

export const useProductDocumentType = () =>
  useQuery({
    queryKey: [USE_PRODUCT_DOCUMENT_TYPE],
    queryFn: getProductDocumentType,
    staleTime: 1000 * 60 * 15,
  });
